// src/services/api/permissionService.js
import axiosInstance from "./axiosInstance";

const PERMISSIONS_BASE_URL = "/permissions";

const permissionService = {
  getAllPermissions: async () => {
    const response = await axiosInstance.get(PERMISSIONS_BASE_URL);
    return response.data;
  },

  /**
   * Get a specific permission by ID
   * @param {string} id - Permission ID
   * @returns {Promise<Object>} Permission details
   */
  getPermissionById: async (id) => {
    const response = await axiosInstance.get(`${PERMISSIONS_BASE_URL}/${id}`);
    return response.data;
  },

  createPermission: async (permissionData) => {
    const response = await axiosInstance.post(
      PERMISSIONS_BASE_URL,
      permissionData,
    );
    return response.data;
  },

  updatePermission: async (id, permissionData) => {
    const response = await axiosInstance.put(
      `${PERMISSIONS_BASE_URL}/${id}`,
      permissionData,
    );
    return response.data;
  },

  deletePermission: async (id) => {
    await axiosInstance.delete(`${PERMISSIONS_BASE_URL}/${id}`);
  },
};

export default permissionService;
